/**
 * Sound Visualizer
 *
 * 5-bar audio wave animation that plays when notification sound triggers.
 */

import React from 'react';
import { Box, keyframes } from '@mui/material';
import { useHUDTheme } from '../theme';

const waveAnimation = keyframes`
  0%, 100% {
    transform: scaleY(0.3);
  }
  50% {
    transform: scaleY(1);
  }
`;

interface SoundVisualizerProps {
  isPlaying: boolean;
}

export default function SoundVisualizer({ isPlaying }: SoundVisualizerProps) {
  const { hud } = useHUDTheme();
  const bars = [0, 1, 2, 3, 4];

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '3px',
        height: 24,
        opacity: isPlaying ? 1 : 0.3,
        transition: 'opacity 0.3s ease',
      }}
    >
      {bars.map((index) => (
        <Box
          key={index}
          sx={{
            width: 4,
            height: '100%',
            bgcolor: hud.accent,
            borderRadius: 1,
            transformOrigin: 'center',
            animation: isPlaying
              ? `${waveAnimation} 0.5s ease-in-out infinite`
              : 'none',
            animationDelay: `${index * 0.1}s`,
            transform: isPlaying ? undefined : 'scaleY(0.3)',
          }}
        />
      ))}
    </Box>
  );
}
